// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import * as firebase from 'firebase';
import 'firebase/firestore';
import '@/assets/css/site.css'

Vue.config.productionTip = false

// firebase init goes here
const config = {
  apiKey: "AIzaSyAvLTi5EXlPB_ziUv5MATkKv9JDZ_gf7q8",
  authDomain: "hydrorebates-staging.firebaseapp.com",
  databaseURL: "https://hydrorebates-staging.firebaseio.com",
  projectId: "hydrorebates-staging",
  storageBucket: "hydrorebates-staging.appspot.com",
  messagingSenderId: "545647069805",
  appId: "1:545647069805:web:4fe9b4c304ec4c4bce0d64"
}

firebase.initializeApp(config)

// Get a reference to the storage service, which is used to create references in your storage bucket
var storage = firebase.storage();

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

// date issue fix according to firebase

export {
    db,
    auth,
    currentUser
}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js